
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetorajshthancab() {



    const cardData =
    {
        keyword: 'Pune to Rajasthan Cab',
        heading: 'Meghana Cab : Pune to Rajasthan Cab',
        headingDescription: 'Meghana Cab offers Pune to Rajasthan Cab services, perfect for long-distance travel with comfort, safety, and convenience. Whether you are planning a heritage tour, family vacation, or business visit, our well-maintained cabs and experienced drivers ensure a smooth and enjoyable journey across states. Choose from a range of vehicles suited to your travel needs, and benefit from transparent pricing, flexible bookings, and 24/7 support. Book your Pune to Rajasthan Cab with Meghana Cab and explore the royal state with peace of mind.',


        top: 'Top Places to Visit in Rajasthan with Meghana Cab',

"topPlaces": [
  {
    "title": "Jaipur – The Pink City",
    "description": "Rajasthan’s capital is known for its historic palaces, forts, and vibrant bazaars. Key attractions include the Hawa Mahal, City Palace, Jantar Mantar, Amber Fort, and the bustling Johari Bazaar. The city's pink sandstone buildings and heritage ambiance offer an immersive royal experience."
  },
  {
    "title": "Udaipur – The City of Lakes",
    "description": "Famous for its serene lakes and romantic charm, Udaipur features attractions such as City Palace, Lake Pichola, Jag Mandir, and Sajjangarh (Monsoon Palace). The old city streets, ghats, and rooftop cafes overlooking the water make it a favorite destination for travelers."
  },
  {
    "title": "Jodhpur – The Blue City",
    "description": "Dominated by the majestic Mehrangarh Fort, Jodhpur offers sweeping views of its blue-painted houses. Other highlights include Jaswant Thada, Umaid Bhawan Palace, and the bustling Sardar Market. It’s a rich mix of regal architecture and Rajasthani culture."
  },
  {
    "title": "Jaisalmer – The Golden City",
    "description": "Situated in the heart of the Thar Desert, Jaisalmer is known for its yellow sandstone architecture. The massive Jaisalmer Fort, Patwon Ki Haveli, Sam Sand Dunes, and desert camel safaris make it a unique cultural experience."
  },
  {
    "title": "Mount Abu – The Hill Station of Rajasthan",
    "description": "The only hill station in Rajasthan, Mount Abu offers cool weather, scenic viewpoints, and the famous Dilwara Jain Temples. Nakki Lake, Sunset Point, and Guru Shikhar are also popular with visitors seeking a nature retreat."
  },
  {
    "title": "Pushkar",
    "description": "A sacred town known for the Brahma Temple and the Pushkar Lake, it also hosts the annual Pushkar Camel Fair, a vibrant cultural festival. The town's spiritual ambiance and bohemian vibe attract both pilgrims and international travelers."
  },
  {
    "title": "Ranthambore National Park",
    "description": "One of India’s premier wildlife destinations, Ranthambore is home to Bengal tigers, leopards, sloth bears, and numerous bird species. Safaris through its dry deciduous forests offer opportunities to spot wildlife amid ancient ruins and lakes."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "This UNESCO World Heritage Site is the largest fort in India, spread over 700 acres. It symbolizes Rajput valor and sacrifice, with structures like Vijay Stambh, Kirti Stambh, Rana Kumbha’s Palace, and the Padmini Palace narrating tales of resistance and pride."
  },
  {
    "title": "Bikaner",
    "description": "Known for its camel breeding farm and Junagarh Fort, Bikaner also offers desert festivals, intricately designed havelis, and delicious local snacks like bhujia. It is less commercialized and ideal for a more relaxed exploration of desert culture."
  },
  {
    "title": "Alwar and Sariska",
    "description": "A historic city surrounded by Aravalli hills, Alwar is home to the Bala Quila, City Palace, and the haunted Bhangarh Fort. Nearby Sariska Tiger Reserve offers a mix of wildlife safaris and temple visits in a rugged forested setting."
  }
],

"services": [
    {
        "name": "Pune to Rajasthan Outstation Taxi",
        "description": "Meghana Cab offers reliable and comfortable outstation taxi services from Pune to Rajasthan. Whether you're planning a vacation or a business trip, enjoy a smooth and safe long-distance journey with experienced drivers and well-maintained vehicles."
    },
    {
        "name": "Book a Cab Pune to Rajasthan",
        "description": "Easily book your Pune to Rajasthan cab with Meghana Cab through our online platform or customer support. Choose from a variety of vehicles and travel with ease across cities like Jaipur, Udaipur, Jodhpur, and more."
    },
    {
        "name": "Pune to Jaipur Cab Service",
        "description": "Travel comfortably from Pune to Jaipur with Meghana Cab’s long-distance taxi service. Our punctual drivers, AC vehicles, and route familiarity ensure a safe and stress-free road trip to the Pink City."
    },
    {
        "name": "Long Distance Cab Pune to Rajasthan",
        "description": "Planning a road trip from Pune to Rajasthan? Meghana Cab provides long-distance cab options tailored for extended journeys with ample legroom, luggage space, and professional chauffeurs ensuring a comfortable travel experience."
    },
    {
        "name": "Rajasthan Trip from Pune by Car",
        "description": "Enjoy a personalized road trip from Pune to Rajasthan with Meghana Cab. Stop along scenic routes, explore tourist spots at your pace, and make memories while we take care of the driving and logistics."
    },
    {
        "name": "One Way Cab Pune to Rajasthan",
        "description": "Looking for a one-way cab from Pune to Rajasthan? Meghana Cab offers affordable one-way taxi services with transparent fares, no return charges, and flexible pickup points across Pune."
    },
    {
        "name": "Round Trip Cab to Rajasthan from Pune",
        "description": "Planning a return journey to and from Rajasthan? Book a round-trip cab with Meghana Cab and benefit from discounted pricing, round-the-clock support, and reliable return travel on your schedule."
    },
    {
        "name": "Affordable Rajasthan Taxi Pune",
        "description": "Travel to Rajasthan from Pune without overspending. Meghana Cab offers affordable taxi packages for Rajasthan routes, balancing cost-effectiveness with comfort and safety."
    },
    {
        "name": "SUV Rental Pune to Rajasthan",
        "description": "Need more space and power for a long journey? Meghana Cab’s SUV rentals are ideal for Pune to Rajasthan travel, especially for families or groups carrying luggage."
    },
    {
        "name": "AC Cab Pune to Rajasthan Road Trip",
        "description": "Embark on a cool and relaxing road trip with Meghana Cab’s air-conditioned vehicles. Our Pune to Rajasthan AC cab service ensures maximum comfort even on long drives under the sun."
    },
    {
        "name": "Rajasthan Tour Cab from Pune",
        "description": "Explore Rajasthan’s rich heritage with Meghana Cab’s Rajasthan tour taxi service from Pune. Perfect for visiting Jaipur, Udaipur, Jaisalmer, Mount Abu, and more—all in one seamless trip."
    },
    {
        "name": "Online Cab Booking Pune to Rajasthan",
        "description": "Book your Rajasthan cab online from Pune in just a few clicks. Meghana Cab’s booking portal offers real-time availability, instant confirmation, and flexible scheduling."
    },
    {
        "name": "Private Cab Hire Pune to Rajasthan",
        "description": "Enjoy the privacy and convenience of a dedicated vehicle for your Pune to Rajasthan journey. Meghana Cab’s private taxi hire ensures door-to-door service, safe driving, and customizable routes."
    },
    {
        "name": "Pune to Udaipur Taxi",
        "description": "Planning a trip to the City of Lakes? Meghana Cab provides Pune to Udaipur taxi services with experienced drivers and clean, comfortable vehicles ideal for sightseeing and leisure travel."
    },
    {
        "name": "Sedan for Pune to Rajasthan Travel",
        "description": "Choose Meghana Cab’s sedan option for a smooth and economical journey from Pune to Rajasthan. Perfect for solo travelers or small families seeking comfort and affordability."
    }
],

"tableData": [
    ["Pune to Rajasthan Outstation Taxi", "Book a Cab Pune to Rajasthan"],
    ["Pune to Jaipur Cab Service", "Long Distance Cab Pune to Rajasthan"],
    ["Rajasthan Trip from Pune by Car", "One Way Cab Pune to Rajasthan"],
    ["Round Trip Cab to Rajasthan from Pune", "Affordable Rajasthan Taxi Pune"],
    ["SUV Rental Pune to Rajasthan", "AC Cab Pune to Rajasthan Road Trip"],
    ["Rajasthan Tour Cab from Pune", "Online Cab Booking Pune to Rajasthan"],
    ["Private Cab Hire Pune to Rajasthan", "Pune to Udaipur Taxi"],
    ["Sedan for Pune to Rajasthan Travel", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Rajasthan Cab Service",
        "WhyChoosedescription": "Meghana Cab offers long-distance cab services from Pune to Rajasthan, ensuring a smooth and comfortable journey across states. Ideal for family vacations, business travel, or cultural tours."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
        "WhyChoosedescription": "Our drivers are well-trained for interstate travel and familiar with the best routes to Rajasthan. They prioritize safety, comfort, and timely arrival throughout the journey."
    },
    {
        "WhyChooseheading": "Flexible Pickup and Drop Across Rajasthan",
        "WhyChoosedescription": "Whether you're heading to Jaipur, Udaipur, Jodhpur, or any other city in Rajasthan, we offer flexible pick-up and drop-off options based on your travel plan."
    },
    {
        "WhyChooseheading": "Clean, Air-Conditioned & Sanitized Vehicles",
        "WhyChoosedescription": "Travel long distances in comfort. All our cabs are sanitized, well-maintained, and equipped with air conditioning, spacious seating, and essential safety features."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy honest and upfront pricing for your Pune to Rajasthan cab. Our fares are competitive and include everything—no surprises, just reliable service."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans and Stopovers",
        "WhyChoosedescription": "Want to explore places along the way? Meghana Cab offers customized itineraries and optional stopovers, making your road trip to Rajasthan even more enjoyable."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability for Interstate Rides",
        "WhyChoosedescription": "Plan your Pune to Rajasthan journey at your convenience. Our cab services are available 24/7 to match your schedule, even for early morning or late-night departures."
    },
    {
        "WhyChooseheading": "Easy Booking and Reliable Support",
        "WhyChoosedescription": "Book your Pune to Rajasthan cab online in just a few clicks. Our customer support team is available round-the-clock to assist with bookings, changes, or queries."
    }
]
































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Rajasthan with Meghana Cab?",
        answer: "You can book a Pune to Rajasthan cab by calling Meghana Cab at +91 9075462128 or through our website for easy online booking."
    },
    {
        question: "What types of vehicles are available for Pune to Rajasthan trips?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for long-distance travel and varying group sizes."
    },
    {
        question: "Are the drivers experienced for long-distance Pune to Rajasthan journeys?",
        answer: "Yes, our drivers are skilled, experienced, and familiar with the routes between Pune and Rajasthan to ensure a safe journey."
    },
    {
        question: "Can I hire a cab for a round trip from Pune to Rajasthan?",
        answer: "Absolutely! We provide both one-way and round-trip cab services for Pune to Rajasthan travel."
    },
    {
        question: "What is included in the Pune to Rajasthan cab fare?",
        answer: "The fare typically includes driver charges, vehicle maintenance, and fuel. Toll, parking, and interstate taxes may be extra."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Rajasthan bookings?",
        answer: "Yes, our booking services operate 24/7 to assist you with your travel plans."
    },
    {
        question: "Can I book a cab for a group traveling from Pune to Rajasthan?",
        answer: "Yes, we offer various vehicle options including tempo travellers for larger groups."
    },
    {
        question: "Are the vehicles sanitized and safe for travel?",
        answer: "All our vehicles are regularly cleaned and sanitized to ensure passenger safety and comfort."
    },
    {
        question: "What payment methods are accepted for Pune to Rajasthan cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab for Pune to Rajasthan cab services?",
        answer: "Call Meghana Cab at +91 9075462128 for bookings, inquiries, and travel assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sunil Choudhary',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Rajasthan cab service from Meghana Cab was excellent. The driver was professional and the vehicle was comfortable for the long journey.”',
    },
    {
        name: 'Mrs. Kavita Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We traveled from Pune to Rajasthan with Meghana Cab and had a smooth and pleasant experience. Highly recommend for long-distance travel.”',
    },
];

























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-rajasthan-cab.jpg",
  "description": "Book Pune to Rajasthan cab services with Meghana Cabs for affordable, reliable, and comfortable travel. Options for one-way, round trip, AC sedan, SUV, and long-distance rides.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5205"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-rajasthan-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Rajasthan Cab | Outstation Taxi Services | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Rajasthan cab services with Meghana Cabs for affordable, reliable, and comfortable travel. Options for one-way, round trip, AC sedan, SUV, and long-distance rides." 
  />
  <meta 
    name="keywords" 
    content="Pune to Rajasthan Outstation Taxi, Book a Cab Pune to Rajasthan, Pune to Jaipur Cab Service, Long Distance Cab Pune to Rajasthan, Rajasthan Trip from Pune by Car, One Way Cab Pune to Rajasthan, Round Trip Cab to Rajasthan from Pune, Affordable Rajasthan Taxi Pune, SUV Rental Pune to Rajasthan, AC Cab Pune to Rajasthan Road Trip, Rajasthan Tour Cab from Pune, Online Cab Booking Pune to Rajasthan, Private Cab Hire Pune to Rajasthan, Pune to Udaipur Taxi, Sedan for Pune to Rajasthan Travel" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetorajshthancab;